// NF-242: announce the header search state to screen readers.
// The Sprig component is replaced on every response, so the live region lives outside it
// and only receives text rendered (and translated) by Twig.
(function () {
	const searchRegion = document.querySelector('#header-search')
	const status = document.querySelector('#header-search-status')

	if (!searchRegion || !status) {
		return
	}

	const announce = (text) => {
		status.textContent = ''
		requestAnimationFrame(() => {
			status.textContent = text
		})
	}

	const isHeaderSearchEvent = (evt) => evt.target instanceof Element && searchRegion.contains(evt.target)

	document.body.addEventListener('htmx:beforeRequest', (evt) => {
		if (!isHeaderSearchEvent(evt)) {
			return
		}

		announce(status.dataset.searchingText || '')
	})

	document.body.addEventListener('htmx:afterSettle', (evt) => {
		if (!isHeaderSearchEvent(evt)) {
			return
		}

		const outcome = searchRegion.querySelector('[data-header-search-outcome]')

		// No search ran (term too short): don't leave "searching" behind
		if (!outcome) {
			status.textContent = ''
			return
		}

		announce(outcome.textContent.trim())
	})
})()
